import { render, staticRenderFns } from "./BP4202Component.vue?vue&type=template&id=52adc2b8&scoped=true&"
import script from "./BP4202Component.vue?vue&type=script&lang=js&"
export * from "./BP4202Component.vue?vue&type=script&lang=js&"
import style0 from "./BP4202Component.vue?vue&type=style&index=0&id=52adc2b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52adc2b8",
  null
  
)

export default component.exports